import ErrorView from 'features/ErrorView'
import React from 'react'

const NotFoundView = React.memo(() => (
  <ErrorView
    errorMessage='404 — Page not found'
    description="The page you're looking for doesn't exist or may have moved. Check the URL, or head back to a page that does."
    actionButton={{
      label: 'Back to homepage',
      onClick: () => {
        window.location.href = '/'
      },
    }}
  />
))

if (process.env.NODE_ENV !== 'production') {
  NotFoundView.displayName = 'NotFoundView'
}

export default NotFoundView
